module.exports = __webpack_public_path__ + "media/components/Influencers/Accounts/Edit/caution-44b4f0f791795ceda13606852dfc3ad3.png";